<h1 class="news--heading head-underline__orange">{{ 'dpNews.allNews' | cxTranslate }}</h1>
@if (maxItems$ | async; as maxItems) {
  <div class="news--content">
    @for (item of newsList$ | async | slice:0:maxItems; track item.description) {
      <dp-news-carousel-item [item]="item"></dp-news-carousel-item>
    }
  </div>
  @if (expandable$ | async) {
    <div class="news--more">
      <button
        class="btn btn-secondary"
        (click)="loadMore()"
        [attr.aria-label]="'dpPLP.list.buttonShowMore' | cxTranslate" >
        {{ 'dpPLP.list.buttonShowMore' | cxTranslate }}
      </button>
    </div>
  }
}
